var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M5.835 2.292c-1.346 0-2.563.336-3.446 1.157-.892.828-1.346 2.057-1.346 3.635v5.833c0 1.578.454 2.807 1.346 3.635.883.82 2.1 1.157 3.446 1.157h8.333c1.346 0 2.563-.337 3.446-1.157.892-.828 1.346-2.057 1.346-3.635V7.084c0-1.578-.454-2.807-1.346-3.635-.883-.82-2.1-1.157-3.446-1.157H5.835Zm10.19 4.677a.625.625 0 0 0-.764-.99l-4.623 3.573c-.375.29-.899.29-1.274 0L4.742 5.98a.625.625 0 1 0-.764.989L8.6 10.54a2.292 2.292 0 0 0 2.803 0l4.622-3.572Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail1);
export default __webpack_public_path__ + "static/media/email 1.ab040ff5be21491dbc91e3b13ea4909e.svg";
export { ForwardRef as ReactComponent };